<template>
  <section class="advantage section">
    <span id="advantage" class="anchor"></span>
    <div class="advantage__container section__container container">
      <h2 class="advantage__heading heading-reset section__heading">
        <span>Наши</span> преимущества
      </h2>
      <ul class="advantage__list list-reset">
        <li class="advantage__list-item">
          <span class="advantage__list-icon icon-1"></span>
          комиссия 10%
        </li>
        <li class="advantage__list-item">
          <span class="advantage__list-icon icon-2"></span>
          от всех выплат клиента
        </li>
        <li class="advantage__list-item">
          <span class="advantage__list-icon icon-3"></span>
          в валюте дохода
        </li>
        <li class="advantage__list-item">
          <span class="advantage__list-icon icon-4"></span>
          в течение 1 года с&nbsp;даты договора
        </li>
        <li class="advantage__list-item">
          <span class="advantage__list-icon icon-5"></span>
          прозрачная система отчётов
        </li>
      </ul>
      <GetPartnerBtn class="advantage__link"/>
    </div>
  </section>
</template>

<style scoped>
.advantage__list {
  display: flex;
  flex-wrap: wrap;
  align-self: center;
  margin-bottom: 64px;
  width: 100%;
  justify-content: space-between;
}

.advantage__list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 222px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
}

.advantage__list-icon {
  display: block;
  margin-bottom: 16px;
  width: 56px;
  height: 56px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.icon-1 {
  background-image: url(@/assets/img/advantage_1.png);
}

.icon-2 {
  background-image: url(@/assets/img/advantage_2.png);
}

.icon-3 {
  background-image: url(@/assets/img/advantage_3.png);
}

.icon-4 {
  background-image: url(@/assets/img/advantage_4.png);
}

.icon-5 {
  background-image: url(@/assets/img/advantage_5.png);
}

.advantage__link {
  align-self: center;
}

@media (max-width: 1160px) {
  .advantage__list {
    justify-content: center;
  }

  .advantage__list-item {
    padding: 0 10px;
    flex: 1 0 25%;
  }

  .advantage__list-item:not(:last-child) {
    margin-bottom: 25px;
  }
}

@media (max-width: 769px) {
  .advantage__list-item {
    flex: 1 0 33.3%;
    font-size: 0.7em;
  }
}

@media (max-width: 600px) {
  .advantage__list {
    margin-bottom: 30px;
  }

  .advantage__list-item {
    flex: 1 0 50%;
  }

  .advantage__list-icon {
    width: 44px;
    height: 44px;
  }
}
</style>

<script>
import GetPartnerBtn from '@/components/GetPartnerBtn.vue'
export default {
  components: { GetPartnerBtn }
}
</script>
